<icc-list
    [items]="systems"
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    [selected]="selectedSystem$ | async"
    (select)="selectSystem($event)"
    (showInfo)="showInfo($event)"
></icc-list>
